// extracted by mini-css-extract-plugin
export var root = "TgFz";
export var rootDescription = "PR19";
export var rootHeading = "kfML";